<template>
  <div class="brand" @click="$router.push('/')">
    <img src="/logo.png" alt="logo" class="logo" />
    <div class="brand-name">Zbeacon</div>
  </div>
</template>

<script>
export default { name: 'Logo' }
</script>

<style scoped>
.brand { display:flex; gap:10px; align-items:center; cursor:pointer }
.logo { width:48px; height:48px }
.brand-name { font-weight:700; color:#0b7fc6 }
</style>
